import { render, staticRenderFns } from "./DemandDetial.vue?vue&type=template&id=35b94d8a"
import script from "./DemandDetial.vue?vue&type=script&lang=js"
export * from "./DemandDetial.vue?vue&type=script&lang=js"
import style0 from "./DemandDetial.vue?vue&type=style&index=0&id=35b94d8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports